export default __webpack_public_path__ + "static/media/Banner@3x.c25bf0e3.png";